export const initialState = {
  modalType: null,
  modalProps: {},
};

const prepareModalProps = (props) => {
  if (!props) return props;
  const prepared = { ...props };
  const loc = prepared.location;
  if (loc && typeof loc === 'object') {
    prepared.location = {
      pathname: loc.pathname,
      search: loc.search,
      hash: loc.hash,
    };
  }
  return prepared;
};

export const modal = (state = initialState, action) => {
  switch (action.type) {
    case 'SHOW_DIALOG':
      return { modalType: action.modalType, modalProps: prepareModalProps(action.modalProps) };
    case 'HIDE_DIALOG':
      return initialState;
    default:
      return state;
  }
};

export const selectModal = (state) => {
  return {
    modalType: state.modal?.modalType,
    modalProps: state.modal?.modalProps,
  };
};
